import { MenuItem } from "../components/navigation/MenuItemRenderer";

export const menuItems: MenuItem[] = [
  { name: "Home", target: "internal", href: "/" },
  {
    name: "Testing",
    type: "group",
    children: [
      { name: "Exams & Prep", target: "internal", href: "/exams" },
      { name: "Certification Tracks", target: "internal", href: "/certifications" },
      { name: "Testing Events", target: "internal", href: "/testing-events" },
    ]
  },
  { name: "About", target: "internal", href: "/about" },
  { name: "FAQ's", target: "internal", href: "/faqs" },
  { name: "Links & Downloads", target: "internal", href: "/resources" },
  { name: "Log In", target: "external", href: "https://register.evtcc.org" },
  {
    name: "EVTCC on Facebook",
    type: "icon",
    img: "/Facebook_Logo_Primary.png",
    target: "external",
    href: "https://www.facebook.com/profile.php?id=100067387294562"
  }
];